import { SAVE_BEAUTY_CONSULTATION_DIAGNOSIS_USER_DATA, SAVE_BEAUTY_CONSULTATION_DIAGNOSIS } from '@/redux/constants';

export const saveBeautyConsultationDiagnosisUserData = data => ({
  type: SAVE_BEAUTY_CONSULTATION_DIAGNOSIS_USER_DATA,
  payload: data,
});

export const saveBeautyConsultationDiagnosis = data => ({
  type: SAVE_BEAUTY_CONSULTATION_DIAGNOSIS,
  payload: data,
});



// WEBPACK FOOTER //
// ./src/redux/actions/beautyConsultationDiagnosis.js